export class CampusUnitsFaq {
  campusUnitsFaqId: number;
  question: string;
  answer: string;
  questionOrder: number;
  updatedBy: string;
  updatedOn: Date;
  campusUnitsFaqSectionId: number;
  active: boolean;
}
